import httpClient from "./httpClient";

const AccessTierService = {
  async findAll() {
    return await httpClient.get("/access-tier");
  },
};

export default AccessTierService;
